import home from './src/home.vue'
import preview from './src/preview.vue'
import upload from './src/upload.vue'
import chat from './src/chat.vue'
import socket from './src/socket.vue'
import player from './src/player.vue'
import playerTree from './src/player-tree.vue'
import wfsplayer from './src/wfsplayer.vue'
import meeting from './src/meeting.vue'
import broadcast from './src/broadcast.vue'
import VoiceChat from './src/VoiceChat.vue'

let views = {
    home,
    preview,
    upload,
    chat,
    socket,
    player,
    playerTree,
    wfsplayer,
    meeting,
    broadcast,
    VoiceChat
};

export default views;